import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

const TOKEN_KEY = 'gymflow-jwt';

export const tokenStore = {
    get: () => localStorage.getItem(TOKEN_KEY),
    set: (t) => localStorage.setItem(TOKEN_KEY, t),
    clear: () => localStorage.removeItem(TOKEN_KEY),
};

api.interceptors.request.use((config) => {
    const t = tokenStore.get();
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return 'Something went wrong. Please try again.';
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) =>
                e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)
            )
            .filter(Boolean)
            .join(' ');
    if (detail && typeof detail.msg === 'string') return detail.msg;
    return String(detail);
}
